import React, { useEffect, useState } from 'react'
import api from '../../utils/intercepter/axiosConfig.js';
import { FaCheckCircle } from 'react-icons/fa';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const InitierHypo = () => {

  const navigate = useNavigate();

  const [id_notaire, setIdNotaire] = useState('');
  const [id_user, setIdUser] = useState('');
  const [nom_pro, setNomPro] = useState('');
  const [cni_pro, setCniPro] = useState('');
  const [nomDisabled, setNomDisabled] = useState(true);

  const [allBanques, setAllBanques] = useState([]);
  const [id_banque, setIdBanque] = useState('');

  const [allRangs, setAllRangs] = useState([]);
  const [id_rang, setIdRang] = useState('');

  const [date_hypotheque, setDateHypotheque] = useState('');
  const [num_hypo, setNumHypo] = useState(0);
  const [montant, setMontant] = useState(0);

  const [cercles, setCercles] = useState([]);
  const [nbr_tf_hypotheques, setNbrTfHypotheques] = useState('');
  const [tfDetails, setTfDetails] = useState([]);

  const [statusTF, setStatusTF] = useState(null); // null au début
  const [apiChecked, setApiChecked] = useState(false);

  const options = [1, 2, 3, 4, 5];

  const personnesLocal = [
  { cni: '0000000000', nom: 'Med' },
  { cni: '0000000001', nom: 'Ahmed' },
  { cni: '0000000002', nom: 'Fatima' },
  ];

const handleCheckCni = (nni) => {
  const personne = personnesLocal.find(p => p.cni === nni);

  if (personne) {
    setNomPro(personne.nom);
    setNomDisabled(true); // rester désactivé car trouvé
  } else {
    setNomPro('');
    setNomDisabled(false); // permettre de saisir
  }
};

  const fetchAllBanques = async () => {
    try {
      const response = await api.get("/auth/allBanques");
      if (response.data.status) {
        setAllBanques(response.data.response);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllRangs = async () => {
    try {
      const response = await api.get("/auth/allRangs");
      if (response.data.status) {
        setAllRangs(response.data.response);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllCercles = async () => {
    try {
      const response = await api.get("/auth/allCercle");
      if (response.data.status) {
        setCercles(response.data.response);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllBanques();
    fetchAllRangs();
    fetchAllCercles();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if(token){
      const decoded = jwtDecode(token);
      setIdNotaire(decoded.data.id_notaire);
      setIdUser(decoded.data.id);
    }
  }, []);

  const handleNbrTFChange = (e) => {
    const n = parseInt(e.target.value);
    setNbrTfHypotheques(n);
    const newArray = Array.from({ length: n }, (_, i) => tfDetails[i] || { numeroTF: '', cercle: '', nni: '' });
    setTfDetails(newArray);
  };

  const handleTFChange = (index, field, value) => {
    const updated = [...tfDetails];
    updated[index][field] = value;
    setTfDetails(updated);
  };

  const isFormTFValid = () => {
    return tfDetails.length > 0 && tfDetails.every(tf => tf.numeroTF && tf.cercle && tf.nni);
  };

 const handleSubmit = async (e) => {
  e.preventDefault();


    const payload = {
      tfs: tfDetails.map((tf) => ({
        num_tf: tf.numeroTF,
        id_cercle: tf.cercle,
        cni: tf.nni
      }))
    };

    try {
      const response = await api.post("/auth/CheckTfForHypotheque", payload);
      setApiChecked(true); // l’API a répondu

      if (response.data.status) {
        setStatusTF(true);
      } else {
        setStatusTF(false);
      }
    } catch (error) {
      setStatusTF(false);
      setApiChecked(true); // même en cas d’erreur
      console.log(error);
    }
};


const intierHypo = async (e) => {

  e.preventDefault();

  if (parseFloat(montant) <= 0) {
  alert("Le montant doit être supérieur à zéro.");
  return;
}

  const payload = {
    tfs: tfDetails.map((tf) => ({
      num_tf: tf.numeroTF,
      id_cercle: tf.cercle,
      cni: tf.nni
    })),
    id_banque: id_banque,
    id_rang: id_rang,
    num_hypotheque: num_hypo,
    date_hypotheque: date_hypotheque,
    montant: montant,
    id_notaire: id_notaire,
    id_user: id_user,
    cni_pro: cni_pro,
    nom_pro: nom_pro
  }

  console.log(payload)

  try {
      const response = await api.post('/auth/initierHypotheque',payload);

      if (response.data.status && response.data.id_hypotheque) {
        navigate(`/hypotheque/show/${response.data.id_hypotheque}`);
      } else {
        // console.log(response.data.message)
      }
    } catch (error) {
      console.log(error);
    }

}

  return (
    <div className='container py-5' style={{ paddingBottom: '250px' }}>
      <div className='row justify-content-center'>
        <div className='col-12 col-md-8 col-lg-6'>
          <div className='card'>
            <div className='card-body'>

              {/* Sélection du nombre de TF */}
              <div className='form-group mb-3'>
                <label htmlFor='nbr_tf_hypotheques'>Choisir le nombre de TF hypothéqués</label>
                <select
                  required
                  className='form-select'
                  id='nbr_tf_hypotheques'
                  value={nbr_tf_hypotheques}
                  onChange={handleNbrTFChange}
                >
                  <option value="">Choisir nombre de TF</option>
                  {options.map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              </div>

              {/* Formulaire des TF */}
              {tfDetails.map((tf, index) => (
                <div key={index} className='border p-3 mb-3'>
                  <h6 className="text-primary">TF Hypothéqué #{index + 1}</h6>

                  <div className='form-group mb-2'>
                    <label>Numéro TF</label>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Entrez numéro TF'
                      value={tf.numeroTF}
                      onChange={(e) => handleTFChange(index, 'numeroTF', e.target.value)}
                      required
                    />
                  </div>

                  <div className='form-group mb-2'>
                    <label>Cercle</label>
                    <select
                      className="form-select"
                      value={tf.cercle}
                      onChange={(e) => handleTFChange(index, 'cercle', e.target.value)}
                      required
                    >
                      <option value="">Sélectionnez un cercle</option>
                      {cercles.map((cercle) => (
                        <option key={cercle.id} value={cercle.id}>
                          {cercle.libelle}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='form-group mb-2'>
                    <label>NNI</label>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Entrez NNI'
                      value={tf.nni}
                      onChange={(e) => handleTFChange(index, 'nni', e.target.value)}
                      required
                    />
                  </div>
                </div>
              ))}

              <div className="d-grid mb-3">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-secondary btn-sm"
                  disabled={!isFormTFValid()}
                >
                  Trouver
                </button>
              </div>


              {statusTF === true && (
<form>


              <div className='form-group mb-2'>
                                <label htmlFor='cni_pro'>NNI / NIF</label>

                                         <input
                                          type='text'
                                          id='cni_pro'
                                          className='form-control'
                                          placeholder='Entrez NNI ou NIF'
                                          value={cni_pro}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            setCniPro(value);
                                            handleCheckCni(value);
                                          }}
                                          required
                                        />


                              </div>
                <div className='form-group mb-2'>
                  <label htmlFor='nom_pro'>Nom / Societé</label>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Entrez votre nom ou societé'
                    value={nom_pro}
                    onChange={(e) => setNomPro(e.target.value)}
                    disabled={nomDisabled}
                  />
                </div>

                <div className='form-group mb-2'>
                  <label>Banque</label>
                  <select
                    required
                    className='form-select'
                    value={id_banque}
                    onChange={(e) => setIdBanque(e.target.value)}
                  >
                    <option value=''>Sélectionner une banque</option>
                    {allBanques.map((banque) => (
                      <option key={banque.id} value={banque.id}>
                        {banque.libelle}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='form-group mb-2'>
                  <label>Rang hypothèque</label>
                  <select
                    required
                    className='form-select'
                    value={id_rang}
                    onChange={(e) => setIdRang(e.target.value)}
                  >
                    <option value=''>Sélectionner un rang</option>
                    {allRangs.map((rang) => (
                      <option key={rang.id} value={rang.id}>
                        {rang.libelle}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='form-group mb-2'>
                  <label htmlFor='date_hypotheque'>Date hypothèque</label>
                  <input type='date' className='form-control' name='date_hypotheque'
                   id="date_hypotheque"
                    required 
                    onChange={(e) => setDateHypotheque(e.target.value)}
                    />
                </div>

                <div className='form-group mb-2'>
                  <label htmlFor='montant'>Montant</label>
                  <input type='number' className='form-control' name='montant' id="montant" placeholder='Entrez le montant' required 
                    onChange={(e) => setMontant(e.target.value)}
                  />
                </div>

                <div className='form-group mb-2'>
                  <label htmlFor='num_hypo'>Numéro hypothèque</label>
                  <input type='text' className='form-control' name='' id='num_hypo' placeholder='Entrez le numéro' required 
                    onChange={(e) => setNumHypo(e.target.value)}
                  />
                </div>

                <div className='row'>
                  <div className='col-12'>
                    <button type='button' className='btn btn-success btn-sm w-100' 
                    onClick={intierHypo}
                    >Initier Hypothèque</button>
                  </div>
                </div>
              </form>
)}

{statusTF === false && apiChecked && (
  <div className="alert alert-danger" role="alert">
    Vous ne pouvez pas initier une hypothèque car les informations de TF sont incorrectes.
  </div>
)}



            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InitierHypo;
